import moment from "moment";
import {
  TableCellType,
  TableHeader,
} from "../../../../../components/custom-table/table";
import { NarAgentGridData } from "../../../../../data-model/medicalPaOrdersModel";
import { NarAgentGridTableColumnKeys } from "../../../../../enums/tableColumnKeys";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";
export const NarAgentGridTableHeaders: TableHeader[] = [
  {
    label: "Insurance",
    key: NarAgentGridTableColumnKeys.Insurance,
    order: 1,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Plan",
    key: NarAgentGridTableColumnKeys.Plan,
    order: 2,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "J Code",
    key: NarAgentGridTableColumnKeys.JCode,
    order: 3,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Drug Name",
    key: NarAgentGridTableColumnKeys.DrugName,
    order: 4,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },

  {
    label: "Updated At",
    key: NarAgentGridTableColumnKeys.UpdatedAt,
    order: 5,
    width: 20,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Agent Mode",
    key: NarAgentGridTableColumnKeys.AgentMode,
    order: 6,
    width: 10,
    sortable: true,
    type: TableCellType.TOGGLE_SWITCH,
  },
];

export const generateNarAgentGridTableData = (
  narAgentGridData: NarAgentGridData[],
) => {
  return narAgentGridData.map((narAgentGridData) => {
    return {
      [NarAgentGridTableColumnKeys.Insurance]:
        capitalizeWordsSeperatedByUnderScore(narAgentGridData?.payer ?? ""),
      [NarAgentGridTableColumnKeys.Plan]:
        narAgentGridData?.line_of_business ?? "",
      [NarAgentGridTableColumnKeys.DrugName]: narAgentGridData?.drug_name ?? "",
      [NarAgentGridTableColumnKeys.JCode]: narAgentGridData?.j_code ?? "",
      [NarAgentGridTableColumnKeys.UpdatedAt]: narAgentGridData?.updated_at
        ? moment(narAgentGridData.updated_at).format("MM/DD/YYYY")
        : "NA",
      [NarAgentGridTableColumnKeys.AgentMode]: {
        ...switchOnOff(narAgentGridData),
        gridIdentifier: narAgentGridData?.identifier ?? "",
      },
    };
  });
};

const switchOnOff = (narAgentGridData: NarAgentGridData) => {
  const shouldBeChecked = (data: NarAgentGridData): boolean => {
    return data?.agent_mode === "Human" ? false : true;
  };

  return {
    id: narAgentGridData?.identifier ?? "",
    defaultChecked: shouldBeChecked(narAgentGridData),
    rowData: narAgentGridData,
  };
};
